import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav-item dropdown active" }
const _hoisted_2 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarScrollingDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_3 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarScrollingDropdown"
}

import MenuHeader from "./MenuHeader.vue";
import MenuItem from "./MenuItem.vue";
import {
  NavigationGroup,
  userShouldSeeGroup,
  userShouldSeeItem,
} from "@/shared/services/navigation";
import NavAppName from "@/shared/components/nav/NavAppName.vue";

interface PropsInterface {
  icon?: string;
  title: string;
  items: NavigationGroup[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NavApp',
  props: {
    icon: null,
    title: null,
    items: null
  },
  setup(__props: any) {

const props = __props as {
  icon?: string;
  title: string;
  items: NavigationGroup[];
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createVNode(NavAppName, {
        title: props.title,
        icon: props.icon
      }, null, 8, ["title", "icon"])
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (group) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: group.title
        }, [
          (_unref(userShouldSeeGroup)(group))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(MenuHeader, {
                  title: group.title
                }, null, 8, ["title"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.title
                  }, [
                    (_unref(userShouldSeeItem)(item))
                      ? (_openBlock(), _createBlock(MenuItem, {
                          key: 0,
                          title: item.title,
                          icon: item.icon,
                          link: item.link,
                          class: "ms-3"
                        }, null, 8, ["title", "icon", "link"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})